import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "inner-modal inner-modal--acc" }
const _hoisted_2 = { class: "acc" }
const _hoisted_3 = { class: "acc__inner" }
const _hoisted_4 = { class: "acc__form" }
const _hoisted_5 = { class: "acc__head" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "acc__heading" }, "Forgot Password", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Enter an email address and we'll email you a link to reset your password.", -1 /* HOISTED */)
const _hoisted_8 = { class: "text-danger" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "emailAddress" }, [
  /*#__PURE__*/_createTextVNode("Email address"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { class: "text-center mt-3" }
const _hoisted_13 = {
  key: 1,
  class: "text-center text-green"
}
const _hoisted_14 = { class: "acc__more" }

import {computed, ref} from 'vue';
import { useStore } from 'vuex';
import Cta from "Vue/components/lockDesigner/components/shared/Cta.vue";
import { useRouter } from 'vue-router';
import {UserForgotPassword} from "Api/apis";

export default /*#__PURE__*/_defineComponent({
  props: {
	pathPrefix: String
},
  setup(__props) {

const props = __props

const componentName = 'AccountForgotPasswordModal';
const store = useStore();
const router = useRouter();
const validationErrors = ref<string[]>([]);
const formValidationErrors = ref<any>({});
const requestData = ref<{ emailAddress: string }>({
	emailAddress: "",
});



const createAccount = async() => {
	await router.push(`${props.pathPrefix}/register`);
};

const login = async() => {
	await router.push(`${props.pathPrefix}/login`);
};

const emailSent = ref<boolean>(false);

const send = async() => {
	await UserForgotPassword(requestData.value).then(async(response) => {
		if(response.isErrors) {
			emailSent.value = false;
			if(response.errorDetail.isError) {
				validationErrors.value = response.userFriendlyMessages;
			}
			if(response.formValidationMessages) {
				formValidationErrors.value = response.formValidationMessages;
			}
		} else {
			emailSent.value = true;
		}
	});
};


const closeModal = async() => {
	await store.dispatch('closeModal');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            (validationErrors.value.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(validationErrors.value, (error) => {
                  return (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(error), 1 /* TEXT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          (!emailSent.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "emailAddress",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((requestData.value.emailAddress) = $event)),
                    class: _normalizeClass([`form-control`, formValidationErrors.value?.emailAddress?.length ? 'is-invalid' : ''])
                  }, null, 2 /* CLASS */), [
                    [_vModelText, requestData.value.emailAddress]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formValidationErrors.value?.emailAddress, (error) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_11, " • " + _toDisplayString(error), 1 /* TEXT */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(Cta, {
                    type: "primary",
                    size: "lg",
                    label: "Send",
                    onOnClick: send,
                    icon: [],
                    iconAlignment: "left"
                  })
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, "Password reset request sent. Please allow a few minutes for the mail servers to process your request and send you an email."))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(Cta, {
            type: "outline",
            size: "lg",
            label: "Login",
            onOnClick: login,
            icon: [],
            iconAlignment: "left"
          }),
          _createVNode(Cta, {
            type: "outline",
            size: "lg",
            label: "Create New Account",
            onOnClick: createAccount,
            icon: [],
            iconAlignment: "left"
          })
        ])
      ])
    ]),
    _createElementVNode("button", {
      onClick: closeModal,
      class: "inner-modal__close"
    }, "×")
  ]))
}
}

})